function isMobileDevice() {
  // Some iPadOS versions report platform as 'MacIntel' but have touch support.
  // Treat those as mobile as well so iPad/iPad Pro behave consistently.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Touch capability detection — independent of layout/UA.
// Used to decide whether swiper should accept touch gestures, so tablets
// that render the PC layout (Surface, some Android tablets, hybrid devices)
// can still swipe to change slides.
function hasTouchSupport() {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
}

// Detect iPad / iPadOS (covers iPad Pro which on newer iPadOS reports as MacIntel)
function isIpadPro() {
  // iPad in older UA strings
  if (/iPad/.test(navigator.userAgent)) return true;
  // iPadOS 13+ reports as MacIntel but has touch points > 1
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return false;
}

// ===== Intro Splash (fake loading + intro scene, plays once on page load) =====
(function initIntroSplash() {
  const LOADING_DURATION_MS = 2200;
  const INTRO_DURATION_MS = 4000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function lockSwiper() {
    const mainEl = document.querySelector('.main-swiper');
    const s = mainEl && mainEl.swiper;
    if (!s) return setTimeout(lockSwiper, 100);
    if (s.mousewheel) s.mousewheel.disable();
    if (s.allowTouchMove !== undefined) s.allowTouchMove = false;
  }
  function unlockSwiper() {
    const mainEl = document.querySelector('.main-swiper');
    const s = mainEl && mainEl.swiper;
    if (!s) return;
    if (s.mousewheel) s.mousewheel.enable();
    if (s.allowTouchMove !== undefined) s.allowTouchMove = hasTouchSupport();
  }

  ready(function () {
    const splashEl = document.querySelector('.intro-splash');
    if (isMobileDevice()) {
      splashEl && splashEl.parentNode && splashEl.parentNode.removeChild(splashEl);
      return;
    }
    lockSwiper();
    const loaderEl = splashEl && splashEl.querySelector('.intro-loader');
    const sceneEl = splashEl && splashEl.querySelector('.intro-scene');
    const numEl = splashEl && splashEl.querySelector('.ld-num');
    if (!splashEl || !loaderEl || !sceneEl || !numEl) { unlockSwiper(); return; }

    const startTs = performance.now();
    let displayed = 0;

    function tick() {
      const elapsed = performance.now() - startTs;
      const ratio = Math.min(1, elapsed / LOADING_DURATION_MS);
      const target = Math.floor(ratio * 100);
      if (target > displayed) {
        displayed = target;
        numEl.textContent = displayed;
      }
      if (displayed < 100) {
        requestAnimationFrame(tick);
      } else {
        startIntro();
      }
    }

    function startIntro() {
      setTimeout(function () {
        loaderEl.classList.add('is-hiding');
        sceneEl.classList.add('is-active');

        setTimeout(function () {
          splashEl.classList.add('is-hiding');
          unlockSwiper();
          setTimeout(function () { splashEl.parentNode && splashEl.parentNode.removeChild(splashEl); }, 850);
        }, INTRO_DURATION_MS);
      }, 250);
    }

    requestAnimationFrame(tick);
  });
})();

$(function () {
  $('.layer-rotate').hide();

  // Special: on iPad Pro (iPad / iPadOS) when user rotates the device, reload after 200ms
  // This handles cases where the layout or orientation-specific resources need a fresh load.
  if (isIpadPro()) {
    let lastOrientation = (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) ? 'portrait' : (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) ? 'landscape' : (window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
    let ipadReloadTimer = null;
    function handleIpadOrientationChange() {
      const current = (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) ? 'portrait' : (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) ? 'landscape' : (window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
      if (current === lastOrientation) return; // no change
      lastOrientation = current;
      if (ipadReloadTimer) clearTimeout(ipadReloadTimer);
      ipadReloadTimer = setTimeout(() => {
        // Use location.reload() to refresh the page state
        location.reload();
      }, 200);
    }
    window.addEventListener('orientationchange', handleIpadOrientationChange, { passive: true });
    // Also listen to resize as some browsers emit resize instead
    window.addEventListener('resize', handleIpadOrientationChange, { passive: true });
  }
});

// ===== Swiper setup =====
let swiper;

function initMainSwiper(retry = 0) {

  // Prevent duplicate initialization
  if (swiper) return;
  if (typeof window.Swiper === 'undefined') {
    if (retry < 20) { // thử lại tối đa 20 lần (2s)
      setTimeout(function () { initMainSwiper(retry + 1); }, 100);
    } else {
      console.error('Swiper CDN not loaded after waiting.');
    }
    return;
  }
  swiper = new Swiper('.main-swiper', {
    direction: "vertical",
    slidesPerView: 1,
    effect: 'slide',
    speed: 1000,
    preloadImages: true,
    updateOnImagesReady: true,
    allowTouchMove: hasTouchSupport(),
    mousewheel: true,
    on: {
      slideChange() {
        const activeSlideEl = this.slides && this.slides[this.activeIndex];
        $(activeSlideEl).find('.swiper-loadVideo').each(function () {
          const $this = $(this);
          if ($this.find('video').length > 0) return;
          const videoSrc = $this.data('video');
          $this.append(`
            <video width="100%" height="auto" playsinline muted autoplay loop loading="lazy" style="position: absolute; top: 0; left: 0;">
              <source src="${videoSrc}">
            </video>
          `);
        });
        if (this.isEnd) {
          $('.footer').addClass('active');
        } else {
          $('.footer').removeClass('active');
        }
      }
    }
  });
}

// Gọi hàm khởi tạo Swiper
initMainSwiper();

window.addEventListener("load", function () {
  if ($('#MS__wrapper.iframe').length > 0) return;;

  // Only attempt init again if not already initialized (in case load fires after inline call)
  initMainSwiper();

  // Warm up: force layout, paint & image decode of all slides during idle time
  // so the first user-triggered transition doesn't hit cold-paint cost.
  (function warmupSlides() {
    var run = function () {
      var slides = document.querySelectorAll('.main-swiper .swiper-slide');
      slides.forEach(function (slide) {
        slide.getBoundingClientRect();
        slide.querySelectorAll('img').forEach(function (img) {
          if (img.complete) return;
          if (typeof img.decode === 'function') {
            img.decode().catch(function () {});
          }
        });
      });
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 300);
    }
  })();
});



// ===== PostMessage =====

window.addEventListener('message', function (e) {
  // Nhận tín hiệu scroll biên từ iframe con để chuyển slide cha
  if (e.data && e.data.type === 'iframeScroll' && swiper && !swiper.destroyed) {
    if (e.data.direction === 'next') {
      swiper.slideNext();
    } else if (e.data.direction === 'prev') {
      swiper.slidePrev();
    }
  }
});

// Đảm bảo iframe con gửi đúng thông điệp ra cha
function sendMessageToParent(message) {
  if (window.parent) {
    window.parent.postMessage(message, '*'); // '*' có thể thay bằng nguồn cụ thể nếu cần
  };
}

// ===== Iframe Edge Scroll Messaging =====
// Mục tiêu: Bên trong iframe nếu người dùng scroll tới đỉnh hoặc đáy nội dung
// thì gửi postMessage ra cha để cha chuyển slide (prev/next) thay vì "kẹt".
(function initIframeEdgeScrollMessaging() {
  // Chỉ kích hoạt nếu thực sự đang ở trong iframe
  const inIframe = window.self !== window.top;
  if (!inIframe) return;

  // Tránh trường hợp iframe cũng có swiper chính (đã disable ở trên với #MS__wrapper.iframe)
  // nên logic này chỉ gửi tín hiệu, không tự điều khiển swiper local.

  const LOCK_MS = 600; // mỗi cử chỉ chỉ gửi 1 lần
  let lockUntil = 0;

  function getScrollableAncestor(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      const st = getComputedStyle(el);
      if ((st.overflowY === 'auto' || st.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
        return el;
      }
      el = el.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function atTop(el) {
    return !el || el.scrollTop <= 0;
  }
  function atBottom(el) {
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
  }

  function maybeSend(direction) {
    const now = Date.now();
    if (now < lockUntil) return;
    lockUntil = now + LOCK_MS;
    sendMessageToParent({ type: 'iframeScroll', direction });
  }

  // Wheel (desktop)
  document.addEventListener('wheel', function (e) {
    const now = Date.now();
    if (now < lockUntil) return;
    // Chỉ quan tâm trục dọc
    if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
    const dy = e.deltaY;
    if (Math.abs(dy) < 20) return; // bỏ nhiễu nhẹ hơn
    // Gửi direction mỗi lần wheel (không cần đợi chạm biên)
    if (dy > 0) {
      maybeSend('next');
    } else if (dy < 0) {
      maybeSend('prev');
    }
  }, { passive: true });

  // Touch (mobile)
  let touchStartY = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    const touch = e.changedTouches && e.changedTouches[0];
    if (!touch) return;
    const deltaY = touchStartY - touch.clientY; // >0 kéo lên (hướng nội dung đi xuống)
    if (Math.abs(deltaY) < 60) return; // ngưỡng ý định
    const scrollable = getScrollableAncestor(e.target);
    if (deltaY > 0 && atBottom(scrollable)) {
      maybeSend('next');
    } else if (deltaY < 0 && atTop(scrollable)) {
      maybeSend('prev');
    }
  }, { passive: true });
})();

// ===== Auto Shine Effect =====
var ShineInstances = [];

function updateShineByActiveSlide() {
  var mainEl = document.querySelector('.main-swiper');
  var s = mainEl && mainEl.swiper;
  var activeSlide = s ? s.slides[s.activeIndex] : null;
  ShineInstances.forEach(function (inst) {
    var shouldRun = !inst.slide || inst.slide === activeSlide;
    if (shouldRun) inst.start();
    else inst.stop();
  });
}

function initEffectHover() {
  $('.MS__hover-shine').each(function () {
    var el = this;
    var $el = $(this);
    var style = window.getComputedStyle(el);

    function extractBgUrl() {
      var s = window.getComputedStyle(el);
      var bi = s.backgroundImage;
      if (!bi || bi === 'none') return null;
      var match = bi.match(/url\((['"]?)(.+?)\1\)/);
      return match ? match[2] : null;
    }

    var spriteUrl = extractBgUrl();
    if (!spriteUrl) {
      var fallback = $el.attr('data-sprite-url');
      if (fallback && fallback !== 'none') {
        if (/^url\(/i.test(fallback)) {
          var fallbackMatch = fallback.match(/url\((['"]?)(.+?)\1\)/);
          spriteUrl = fallbackMatch ? fallbackMatch[2] : null;
        } else {
          spriteUrl = fallback;
        }
      }
    }

    if (!spriteUrl) {
      console.warn('initEffectHover: missing background-image for element', el);
      return;
    }

    style = window.getComputedStyle(el);
    var bgPosValue = style.backgroundPosition || '0px 0px';
    var bgPosParts = bgPosValue.split(/\s+/);
    if (bgPosParts.length === 1) bgPosParts[1] = '0px';
    var bgX = parseInt(bgPosParts[0], 10);
    if (isNaN(bgX)) bgX = 0;
    var bgY = parseInt(bgPosParts[1], 10);
    if (isNaN(bgY)) bgY = 0;

    var width = 0;
    var height = 0;

    var canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.pointerEvents = 'none';
    canvas.style.opacity = 1;
    canvas.style.zIndex = 1;

    if (style.position === '' || style.position === 'static') {
      $el.css('position', 'relative');
    }
    $el.css('overflow', 'hidden');

    $el.children().css({
      position: 'relative',
      zIndex: 2
    });

    $el.append(canvas);

    var ctx = canvas.getContext('2d');
    var image = new Image();
    var maskReady = false;

    var lightX = -200;
    var SPEED = 900; // pixels per second
    var LOOP_DELAY = 2000;
    var animId = null;
    var loopTimeoutId = null;
    var lastTs = 0;
    var resizeObserver = null;

    function refreshDimensions() {
      var newWidth = el.offsetWidth || el.clientWidth;
      var newHeight = el.offsetHeight || el.clientHeight;
      if ((!newWidth || !newHeight) && el.getBoundingClientRect) {
        var rect = el.getBoundingClientRect();
        newWidth = rect.width;
        newHeight = rect.height;
      }
      if (!newWidth || !newHeight) return;
      if (width === newWidth && height === newHeight) return;
      width = newWidth;
      height = newHeight;
      canvas.width = width;
      canvas.height = height;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      drawStatic();
    }

    refreshDimensions();

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].target === el) {
            refreshDimensions();
            break;
          }
        }
      });
      resizeObserver.observe(el);
    }

    function loadMaskWithRetry() {
      maskReady = false;
      image.onload = function () {
        maskReady = true;
      };
      image.onerror = function () {
        maskReady = false;
        console.warn('initEffectHover: failed to load sprite mask', spriteUrl);
      };
      image.src = spriteUrl;
      if (image.complete && image.naturalWidth > 0) {
        maskReady = true;
        return;
      }
      if (typeof image.decode === 'function') {
        image.decode().then(function () {
          maskReady = true;
        }).catch(function () {
          maskReady = image.complete && image.naturalWidth > 0;
        });
      }
    }

    loadMaskWithRetry();

    function drawStatic() {
      if (!width || !height) return;
      ctx.clearRect(0, 0, width, height);
    }

    function drawShine(ts) {
      if (!width || !height) {
        animId = requestAnimationFrame(drawShine);
        return;
      }
      if (!lastTs) lastTs = ts || performance.now();
      var now = ts || performance.now();
      var dt = Math.min((now - lastTs) / 1000, 0.1);
      lastTs = now;
      ctx.clearRect(0, 0, width, height);

      var bandWidth = Math.max(width * 0.45, 140);

      var gradient = ctx.createLinearGradient(
        lightX - bandWidth, -height,
        lightX + bandWidth, height * 2
      );

      gradient.addColorStop(0, 'rgba(255,255,255, 0)');
      gradient.addColorStop(0.4, 'rgba(255,255,255, 0.4)');
      gradient.addColorStop(0.5, 'rgba(255,255,255, 0.8)');
      gradient.addColorStop(0.6, 'rgba(255,255,255, 0.4)');
      gradient.addColorStop(1, 'rgba(255,255,255, 0)');

      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      if (maskReady) {
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(
          image,
          -bgX,
          -bgY,
          width,
          height,
          0,
          0,
          width,
          height
        );
      }

      ctx.globalCompositeOperation = 'source-over';

      lightX += SPEED * dt;
      // Gradient nghiêng (2*bandWidth, 3*height) → cần chạy thêm để góc dưới-phải cũng out of range
      var endMargin = bandWidth + (3 * height * height) / Math.max(bandWidth, 1);
      if (lightX > width + endMargin) {
        if (animId) {
          cancelAnimationFrame(animId);
          animId = null;
        }
        ctx.clearRect(0, 0, width, height);
        loopTimeoutId = setTimeout(function () {
          startShine();
        }, LOOP_DELAY);
        return;
      }

      animId = requestAnimationFrame(drawShine);
    }

    function startShine() {
      if (animId) return;
      if (loopTimeoutId) {
        clearTimeout(loopTimeoutId);
        loopTimeoutId = null;
      }
      refreshDimensions();
      lightX = -Math.max(width, 200);
      lastTs = 0;
      animId = requestAnimationFrame(drawShine);
    }

    function stopShine() {
      if (animId) {
        cancelAnimationFrame(animId);
        animId = null;
      }
      if (loopTimeoutId) {
        clearTimeout(loopTimeoutId);
        loopTimeoutId = null;
      }
      if (width && height) ctx.clearRect(0, 0, width, height);
    }

    ShineInstances.push({
      el: el,
      slide: el.closest ? el.closest('.swiper-slide') : null,
      start: startShine,
      stop: stopShine
    });
  });
}


function stopAllShines() {
  ShineInstances.forEach(function (inst) { inst.stop(); });
}

window.addEventListener("load", function () {
  initEffectHover();

  function bindShineToSwiper(retry) {
    retry = retry || 0;
    var mainEl = document.querySelector('.main-swiper');
    var s = mainEl && mainEl.swiper;
    if (s && s.on) {
      s.on('slideChangeTransitionStart', function () {
        document.body.classList.add('is-sliding');
        stopAllShines();
      });
      s.on('slideChangeTransitionEnd', function () {
        document.body.classList.remove('is-sliding');
        updateShineByActiveSlide();
      });
      updateShineByActiveSlide();
      return;
    }
    if (retry < 30) setTimeout(function () { bindShineToSwiper(retry + 1); }, 100);
  }
  bindShineToSwiper();
});

// ===== Light Particles (canvas particle effect) =====
// Ported from love.qq.com/cp/a20191226love, optimized:
//  - Pre-rendered sprites (no per-frame createRadialGradient)
//  - globalAlpha for opacity (single path)
//  - Auto pause when tab hidden / canvas not on active slide
var LightParticles = (function () {
  var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame ||
    function (cb) { return setTimeout(cb, 1000 / 60); };
  var caf = window.cancelAnimationFrame || window.webkitCancelAnimationFrame ||
    function (id) { clearTimeout(id); };

  var canvas, ctx, w, h, rafId, isPlaying = false;
  var spriteCache = {};
  var OPTIONS = {
    AMOUNT: 40,
    COLOR: '255,255,255',
    UPPER_X_LIMIT: 0,
    LOWER_X_LIMIT: 0,
    UPPER_Y_LIMIT: 1,
    LOWER_Y_LIMIT: 1,
    UPPER_SIZE: 6,
    LOWER_SIZE: 2
  };
  var FRAME_COUNT = 0;
  var particles = [];

  function doIt() { return Math.random() > 0.5; }
  function rand(max, min) {
    max = (max === 0 || max) ? max : 1;
    min = min || 0;
    return min + (max - min) * Math.random();
  }
  function floored(r) { return Math.floor(Math.random() * r); }

  // Pre-render a radial-gradient disc for a given (size, r) pair.
  function getSprite(size, r) {
    var key = size + '_' + r;
    if (spriteCache[key]) return spriteCache[key];
    var pad = 2;
    var s = Math.ceil(size * 2 + pad * 2);
    var off = document.createElement('canvas');
    off.width = off.height = s;
    var octx = off.getContext('2d');
    var cx = s / 2, cy = s / 2;
    var grd = octx.createRadialGradient(cx, cy, r, cx, cy, 0);
    var color = 'rgba(' + OPTIONS.COLOR + ',';
    grd.addColorStop(0.0, color + '0)');
    grd.addColorStop(0.2, color + '0.2)');
    grd.addColorStop(0.4, color + '0.2)');
    grd.addColorStop(0.9, color + '1)');
    grd.addColorStop(1.0, color + '1)');
    octx.fillStyle = grd;
    octx.beginPath();
    octx.arc(cx, cy, size, 0, Math.PI * 2);
    octx.fill();
    spriteCache[key] = { img: off, half: s / 2 };
    return spriteCache[key];
  }

  function Particle(i) {
    this.id = i;
    this.build();
  }
  Particle.prototype.build = function () {
    var size = floored(OPTIONS.UPPER_SIZE) + OPTIONS.LOWER_SIZE;
    this.startSize = size;
    this.size = size;
    this.r = rand(OPTIONS.UPPER_SIZE, OPTIONS.LOWER_SIZE);
    this.sprite = getSprite(size, Math.round(this.r));
    var xDelayed = doIt();
    this.startX = floored(w);
    this.startY = xDelayed ? size + floored(h * 0.25) + Math.floor(h * 0.75) : h + size + floored(h);
    this.x = this.startX;
    this.y = this.startY;
    this.vx = rand(OPTIONS.UPPER_X_LIMIT, OPTIONS.LOWER_X_LIMIT);
    this.vy = rand(OPTIONS.UPPER_Y_LIMIT, OPTIONS.LOWER_Y_LIMIT);
    this.opacity = rand(2, 1);
  };
  Particle.prototype.update = function () {
    if (this.y < h || this.startX < 0) this.x += this.vx;
    if (this.x > 0 || this.startY > h) this.y -= this.vy;
    if (this.opacity > 0 && doIt()) this.opacity -= 0.01;
  };
  Particle.prototype.reset = function () {
    this.x = this.startX;
    this.y = this.startY;
    this.opacity = 1;
    this.size = this.startSize;
  };
  Particle.prototype.draw = function () {
    var op = this.opacity;
    if (op <= 0) return;
    if (op > 1) op = 1;
    ctx.globalAlpha = op;
    ctx.drawImage(this.sprite.img, this.x - this.sprite.half, this.y - this.sprite.half);
  };

  function drawScene() {
    ctx.clearRect(0, 0, w, h);
    for (var i = 0, len = particles.length; i < len; i++) {
      var p = particles[i];
      FRAME_COUNT++;
      p.update();
      if (FRAME_COUNT % 11 === 0 && doIt()) {
        p.vx = rand(OPTIONS.UPPER_X_LIMIT, OPTIONS.LOWER_X_LIMIT);
      }
      if (FRAME_COUNT % 13 === 0 && doIt()) {
        p.vy = rand(OPTIONS.UPPER_Y_LIMIT, OPTIONS.LOWER_Y_LIMIT);
      }
      if (p.x > w || p.y < -p.size || p.opacity < 0 || p.size <= 0) {
        p.reset();
      }
      p.draw();
    }
    ctx.globalAlpha = 1;
    rafId = raf(drawScene);
  }

  function init(width, height, canvasEle) {
    particles = [];
    if (rafId) { caf(rafId); rafId = null; }
    canvas = typeof canvasEle === 'string' ? document.querySelector(canvasEle) : canvasEle;
    if (!canvas) return;
    ctx = canvas.getContext('2d');
    w = canvas.width = width;
    h = canvas.height = height;
    for (var i = 0; i < OPTIONS.AMOUNT; i++) particles.push(new Particle(i));
  }

  function start() {
    if (isPlaying || !ctx) return;
    isPlaying = true;
    rafId = raf(drawScene);
  }
  function stop() {
    if (!isPlaying) return;
    isPlaying = false;
    if (rafId) { caf(rafId); rafId = null; }
    if (ctx) ctx.clearRect(0, 0, w, h);
  }
  function destroy() {
    stop();
    particles = [];
    spriteCache = {};
  }

  return { init: init, start: start, stop: stop, destroy: destroy };
})();

window.addEventListener("load", function () {
  var canvasEl = document.querySelector('#particle-canvas');
  if (!canvasEl) return;
  LightParticles.init(1920, 1008, canvasEl);
  LightParticles.start();

  // Pause during slide transitions to free up the main thread.
  function bindTransitionGuard(retry) {
    retry = retry || 0;
    var mainEl = document.querySelector('.main-swiper');
    var s = mainEl && mainEl.swiper;
    if (s && s.on) {
      s.on('slideChangeTransitionStart', function () {
        LightParticles.stop();
      });
      s.on('slideChangeTransitionEnd', function () {
        LightParticles.start();
      });
      return;
    }
    if (retry < 30) setTimeout(function () { bindTransitionGuard(retry + 1); }, 100);
  }
  bindTransitionGuard();

  // Auto pause when tab hidden to save CPU
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) LightParticles.stop();
    else LightParticles.start();
  });
});